import { render } from "./Reference.html?vue&type=template&id=013dbae4&scoped=true&ts=true"
import script from "./Reference.ts?vue&type=script&lang=ts"
export * from "./Reference.ts?vue&type=script&lang=ts"

import "./Reference.css?vue&type=style&index=0&id=013dbae4&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013dbae4"]])

export default __exports__